export const environment = {
  production: true,
  apiURL: 'https://elogweb.psmfc.org/api',
  instrumentationKey: 'bc598e81-1883-428d-b0ca-83f1ac2b603f',
};
